import { parseAsInteger, parseAsString, parseAsStringEnum } from "nuqs";

export const INGREDIENT_CATEGORY_FILTERS = [
  "dairy",
  "egg",
  "sweetener",
  "stabilizer",
  "emulsifier",
  "alcohol",
  "fruit",
  "chocolate",
  "nut",
  "other",
] as const;

export const INGREDIENT_SOURCE_FILTERS = [
  "manual",
  "usda_foundation",
  "usda_fndds",
  "usda_branded",
  "usda_sr_legacy",
  "ifct",
  "user",
] as const;

export type IngredientSourceFilter = (typeof INGREDIENT_SOURCE_FILTERS)[number];

export const ingredientSearchParams = {
  q: parseAsString
    .withDefault("")
    .withOptions({ shallow: false, clearOnDefault: true }),
  category: parseAsStringEnum([...INGREDIENT_CATEGORY_FILTERS]).withOptions({
    shallow: false,
    clearOnDefault: true,
  }),
  source: parseAsStringEnum([...INGREDIENT_SOURCE_FILTERS]).withOptions({
    shallow: false,
    clearOnDefault: true,
  }),
  page: parseAsInteger.withDefault(1).withOptions({
    shallow: false,
    clearOnDefault: true,
  }),
};
